document.addEventListener("DOMContentLoaded", function () {
  var grid       = document.querySelector("#product-grid");
  var pagination = document.querySelector("#collection-pagination");
  var sentinel   = document.querySelector("#infinite-sentinel");
  var loader     = document.querySelector("#infinite-loader");

  if (!grid || !pagination || !sentinel || !loader) return;

  var AUTO_LOADS = 2;
  var loads = 0;
  var loading = false;
  var originalDisplay = pagination.style.display || "";
  pagination.style.display = "none";

  new Ajaxinate({
    container: "#product-grid",
    pagination: "#collection-pagination",
    method: "click",
    loadingText:
      '<div class="spinner-border"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12C24 14.5342 23.1977 17.0033 21.7082 19.0534C20.2187 21.1036 18.1183 22.6296 15.7082 23.4127C13.2981 24.1958 10.7019 24.1958 8.2918 23.4127C5.88167 22.6296 3.78133 21.1036 2.2918 19.0534C0.802259 17.0033 -2.21542e-07 14.5342 0 12C2.21543e-07 9.46585 0.80226 6.99675 2.2918 4.94658C3.78133 2.8964 5.88168 1.37042 8.2918 0.587321C10.7019 -0.195774 13.2981 -0.195774 15.7082 0.587322L14.5957 4.01113C12.9087 3.46296 11.0913 3.46296 9.40426 4.01113C7.71717 4.55929 6.24693 5.62748 5.20426 7.0626C4.16158 8.49772 3.6 10.2261 3.6 12C3.6 13.7739 4.16158 15.5023 5.20426 16.9374C6.24693 18.3725 7.71717 19.4407 9.40426 19.9889C11.0913 20.537 12.9087 20.537 14.5957 19.9889C16.2828 19.4407 17.7531 18.3725 18.7957 16.9374C19.8384 15.5023 20.4 13.7739 20.4 12H24Z" fill="#fff"></path></svg></div>'
  });

  function showLoader() {
    loader.hidden = false;
    loader.setAttribute("aria-busy", "true");
    pagination.querySelector(".load-more")?.setAttribute("aria-disabled", "true");
  }

  function hideLoader() {
    loader.hidden = true;
    loader.setAttribute("aria-busy", "false");
    pagination.querySelector(".load-more")?.removeAttribute("aria-disabled");
  }

  var io = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;

    if (loads >= AUTO_LOADS) {
      io.disconnect();
      pagination.style.display = originalDisplay;
      return;
    }

    var nextLink = pagination.querySelector("a.load-more");
    if (nextLink && !loading) {
      loading = true;
      showLoader();
      nextLink.click();
    } else if (!nextLink) {
      io.disconnect();
      hideLoader();
    }
  }, { rootMargin: "400px 0px 0px 0px" });

  io.observe(sentinel);

  pagination.addEventListener("click", function (e) {
    var link = e.target.closest("a.load-more");
    if (!link) return;
    loading = true; // no showLoader() for manual clicks
  }, true);

  var mo = new MutationObserver(function (mutations) {
    if (!loading) return;

    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type === "childList" && mutations[i].addedNodes.length) {
        loads += 1;
        loading = false;
        hideLoader();

        var nextLink = pagination.querySelector("a.load-more");
        if (!nextLink) {
          io.disconnect();
          pagination.style.display = "none";
        } else if (loads >= AUTO_LOADS) {
          io.disconnect();
          pagination.style.display = originalDisplay;
        }
        break;
      }
    }
  });

  mo.observe(grid, { childList: true });
});
